import React from 'react';
import { SelectItem } from '@/types';
import styles from './autocomplete.module.scss';

interface AutoCompleteOptionProps {
	option: SelectItem;
	onSelect: (value: SelectItem) => void;
}

export const AutoCompleteOption: React.FunctionComponent<AutoCompleteOptionProps> = ({ option, onSelect }) => {
	const handleSelection = () => {
		option && onSelect(option);
	};

	return (
		<button type="button" onClick={handleSelection} key={option.label} className={styles.option}>
			{option.label}
		</button>
	);
};
